import { Component, OnInit } from '@angular/core';
import { ConfigDataService } from '../../services/config-data.service';
// import { ActivatedRoute } from '@angular/router';
import { StringUtilService } from '@core/services/string-util.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  public consumerKeys: string[] = [];

  constructor(
    private configDataService: ConfigDataService,
    public stringUtil: StringUtilService
  ) {
    this.configDataService.getAllConsumerKeys().subscribe((consumerKeys) => {
      this.consumerKeys = consumerKeys;
    });
  }

  ngOnInit(): void { }

  setActiveNode(node): string {
    let cssClass;
    if (false) {
      cssClass = 'active';
    }
    return cssClass;
  }
}
